/** Member (staff) queries — tenant-scoped. */

import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { queryKeys } from '../query-keys';
import { useApiClient } from '../react/ApiClientProvider';
import { type Member, memberSchema } from '../responses';
import { unwrap } from './_helpers';

/** `GET /members` — staff members of the tenant. */
export function useMembers(tenantId: string): UseQueryResult<Member[]> {
  const client = useApiClient();
  return useQuery({
    queryKey: queryKeys.members(tenantId),
    queryFn: async () => {
      const result = await client.GET('/api/v1/tenants/{tenantId}/members', {
        params: { path: { tenantId } },
        parseAs: 'json',
      });
      return unwrap(result, z.array(memberSchema));
    },
  });
}
